import { library, config } from '@fortawesome/fontawesome-svg-core';
import {
  faFacebookF,
  faInstagram,
  faTwitter,
  faWhatsapp,
  faYoutube,
} from '@fortawesome/free-brands-svg-icons';
import {
  faEye,
  faCircle,  
  faHeart as faHeartRegular,
} from '@fortawesome/free-regular-svg-icons';

import {
  faAngleDown,
  faBars,
  faCircleNotch,
  faFilm,
  faImage,
  faMinus,
  faPlus,
  faThLarge,
  faThList,
  faTimes,
  faFireAlt,
  faPepperHot,
  faSignOutAlt,
  faCalendarDay,
  faCalendarWeek,
  faCalendarAlt,
  faCircle as faCircleSolid,
  faSearch,
  faClone,
  faGem,
  faUpload,
  faWindowClose,
  faHeart as faHeartSolid,
  faEllipsisV,
  faCaretSquareUp,
  faPoo,
  faCheck,
  faTv,
  faAngleDoubleDown,
  faAngleLeft,
  faAngleDoubleLeft,
  faAngleRight,
  faAngleDoubleRight,
  faSyncAlt,
  faArrowCircleUp,
  faCog,
  faFlag,
  faLongArrowAltLeft,
  faLongArrowAltRight,
  faRss,
  faLink,
  faBan,
  faListAlt,
  faUser,
  faUserCircle,
  faInfoCircle,
  faComment,
  faFileUpload,
  faMedal,
} from '@fortawesome/free-solid-svg-icons';

export const initIcons = ({ autoAddCss }) => {
  config.autoAddCss = autoAddCss;

  library.add(
    faFacebookF,
    faWhatsapp,
    faInstagram,
    faYoutube,
    faTwitter,
    faEye,
    faThLarge,
    faThList,
    faFilm,
    faImage,
    faPlus,
    faMinus,
    faCircleNotch,
    faBars,
    faTimes,
    faFireAlt,
    faGem,
    faPepperHot,
    faSignOutAlt,
    faCalendarDay,
    faCalendarWeek,
    faCalendarAlt,
    faSearch,
    faClone,
    faUpload,
    faWindowClose,
    faHeartRegular,
    faHeartSolid,
    faEllipsisV,
    faCaretSquareUp,
    faCircle,
    faCircleSolid,
    faPoo,
    faCheck,
    faTv,
    faAngleDown,
    faAngleDoubleDown,
    faAngleLeft,
    faAngleDoubleLeft,
    faAngleRight,
    faAngleDoubleRight,
    faSyncAlt,
    faArrowCircleUp,
    faCog,
    faFlag,
    faLongArrowAltLeft,
    faLongArrowAltRight,
    faRss,
    faLink,
    faBan,
    faListAlt,
    faUser,
    faUserCircle,
    faInfoCircle,
    faComment,
    faFileUpload,
    faMedal,
  );
};

